// @flow

import {Paper, RaisedButton, TextField} from 'material-ui';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as AuthActions from '../../actions/auth';
import logo from '../../assets/images/logo.png';
import './ResetPassword.css';

const queryString = require('query-string');

class ResetPassword extends Component {

  state = {
    password: '',
    passwordConfirmation: '',
  };

  handleChange = (event) => {
    this.setState({[event.target.name]: event.target.value});
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.props.actions.resetPassword({
      token: queryString.parse(this.props.location.search).token,
      password: this.state.password,
      passwordConfirmation: this.state.passwordConfirmation
    });
  };

  render() {
    return (
      <main className="reset-password">
        <div className="reset-password__box">
          <figure className="reset-password__logo">
            <img src={logo} alt="Zoek" />
          </figure>
          <Paper
            className="reset-password__paper"
            zDepth={3}
          >
            <form onSubmit={this.handleSubmit}>
              <TextField
                id="password"
                hintText="Password"
                type="password"
                name="password"
                value={this.state.password}
                onChange={this.handleChange}
                required
              />
              <br />
              <TextField
                id="passwordConfirmation"
                hintText="Confirm Password"
                type="password"
                name="passwordConfirmation"
                value={this.state.passwordConfirmation}
                onChange={this.handleChange}
                errorText={this.props.auth.error}
                required
              />
              <br />
              <RaisedButton
                className="reset-password__button"
                type="submit"
                label="Reset Password"
                primary={true}
                disabled={this.props.auth.loading}
              />
            </form>
          </Paper>
        </div>
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(AuthActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPassword);



// WEBPACK FOOTER //
// ./src/routes/ResetPassword/ResetPassword.js